export const Constants = {
  TAG_NAME: 'pop-calendar-year-chart-component',
  Y_AXIS_LABEL: 'Percentage',
  X_AXIS_LABEL: 'Year',
  PURE_GROSS_SERIES_NAME: '"Pure" Gross',
  NET_SERIES_NAME: 'Net',
  BENCHMARK_SERIES_NAME: 'Benchmark',
} as const;
